<!-- 相关链接 -->
<template>
<div :class="mobileClass('cm_link_container')">
  <!-- 标题 -->
    <div class="cm_link_title">
      <h3>{{data.name}}</h3>
    </div>
     <!-- 内容 -->
    <div >
      <ul class="cm_link_list">
        <li v-for="item in imgData" :key="item.id" @click="toUrl(item.url)">
          <img :src="item.path" >
        </li>
        <li class="cm_link_hover_img">
          <img :src="data.hoverImg[0].path" >
          <span>
            <img src="@/assets/img/link/ewm.jpg" alt="">
          </span>
        </li>
        <li @click="showOther()">
          <div class="cm_link_hover_select"> 
            <img src="@/assets/img/link/bm_logo.png" >
            <span>各省市保密局</span>
            <img src="@/assets/img/link/button.png" >
          </div>
        </li>
        <li v-for="item in otherData" :key="item.id" @click="toUrl(item.url)" class="cm_link_other" v-show="otherIsShow">
          <span>{{item.name}}</span>
        </li>
      </ul>
    </div>
</div>
</template>

<script>


export default {
components: {},
props:["data"],
data() {
//这里存放数据
return {
  imgData:this.data.img,
  otherData:this.data.other,
  otherIsShow:false,
  windowWidth:document.documentElement.clientWidth
};
},
//监听属性 类似于data概念
computed: {
   mobileClass(){
       return (val)=>{
         if(this.windowWidth > 500) {
          return val
          } else {
            return "mobile_"+val
          }
       }
    },
},
//监控data中的数据变化
watch: {
  '$store.state.screenWidth': function (val) { //监听屏幕宽度变化
    this.windowWidth = val;
  }
},
//方法集合
methods: {
  showOther(){
    this.otherIsShow = !this.otherIsShow
  },
  toUrl(url){
    if(url == "" || url == undefined || url == null){

    }else{
      if(/^http[s]?:\/\/.*/.test(url)){
      window.open(url)
    }else{
      const newUrl = this.$router.resolve({path: url})
      window.open(newUrl.href,'_blank')
    }
    }
    
  }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {

},

}
</script>
<style scoped>
  .cm_link_container{
    width: 1200px;
    background: #FFFFFF;
    border: 1px solid #E1E4E7;
    margin-top: 20px;
    padding: 0 20px;
  }
  .cm_link_title{
    width: 80px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 55px;
    border-bottom: 3px solid #4379d3;
  }
  .cm_link_title > h3 {
  font-size: 20px;
  font-weight: 500;
  color: #565656;
  line-height: 33px;
}
.cm_link_list{
  display: flex;
  align-items: center;
  margin-top: 20px;
  flex-wrap: wrap;
}
.cm_link_list>li{
  margin-right: 10px;
  margin-bottom: 20px;
  cursor:pointer;
}
.cm_link_list>li>img{
  width: 180px;
  height: 45px;
}
.cm_link_hover_select{
  width: 198px;
  height: 45px;
  background: #FFFFFF;
  border: 1px solid #EBEBEB;
  display:flex;
  align-items: center;
  padding: 0 8px;
}
.cm_link_hover_select>span{
  display: inline-block;
  margin:0 5px;
  font-size: 14px;
}
.cm_link_other{
  width: 180px;
  height: 45px;
  background: #FFFFFF;
  border: 1px solid #EBEBEB;
  display:flex;
  align-items: center;
  justify-content: center;
}
.cm_link_other:hover>span{
  color:#4379d3;
}
.cm_link_hover_img{
  position: relative;
}
.cm_link_hover_img>span{
  display:none;
  position: absolute;
  top: -132px;
  left: 10px;
  z-index: 100;
}
.cm_link_hover_img:hover>span{
  display: block;
}

.mobile_cm_link_container{
  width: 100%;
  background: #FFFFFF;
  border: 1px solid #E1E4E7;
  margin-top: 20px;
  padding: 0 20px;
}
.mobile_cm_link_container .cm_link_list li{
  max-width: 47%;
}
</style>